import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/schedule/ScheduleClientPage.jsx");
